const DEFAULT_UTM_CAMPAIGN = "web_platform";

export const withUtmCampaign = (
  url: string,
  campaign: string = DEFAULT_UTM_CAMPAIGN,
): string => {
  try {
    const parsed = new URL(url);

    parsed.searchParams.set("utm_campaign", campaign);

    return parsed.toString();
  } catch {
    return url;
  }
};

export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);

    return true;
  } catch {
    return false;
  }
};
